import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import IndexPage from './pages/index'
import AIDevelopmentPage from './pages/services/ai-development'
import MediaTechnologyPage from './pages/services/media-technology'
import VoiceTelecomPage from './pages/services/voice-telecom'
import PrivacyPage from './pages/privacy'
import TermsPage from './pages/terms'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/404'
import { AIPromptProvider } from './context/AIPromptContext'
import { ProjectFormProvider } from './context/ProjectFormContext'
import PortfolioIndexPage from './pages/portfolio'
import OnScriptProjectPage from './pages/portfolio/onscript-ai'

// Project chain pages
import ProjectSurveyPage from './pages/project-chain/ProjectSurvey'
import ProjectThanksPage from './pages/project-chain/ProjectThanks'

// Service pages
import AIForStartupsPage from './pages/services/ai-for-startups'
import VibeCodingPage from './pages/services/vibe-coding'
import AIMLPage from './pages/services/ai-ml-generative'
import DigitalTransformationPage from './pages/services/digital-transformation'
import ConsultingPage from './pages/services/consulting'
import BusinessIntelligencePage from './pages/services/business-intelligence'
import CloudDevelopmentPage from './pages/services/cloud-development'
import WebDevelopmentPage from './pages/services/web-development'
import MobileDevelopmentPage from './pages/services/mobile-development'

function App() {
  return (
    <ProjectFormProvider>
      <AIPromptProvider>
        <ScrollToTop />
        <Routes>
        <Route path="/" element={<IndexPage />} />
        
        {/* Services Routes */}
        <Route path="/services/ai-development" element={<AIDevelopmentPage />} />
        <Route path="/services/media-technology" element={<MediaTechnologyPage />} />
        <Route path="/services/voice-telecom" element={<VoiceTelecomPage />} />
        <Route path="/services/ai-for-startups" element={<AIForStartupsPage />} />
        <Route path="/services/vibe-coding" element={<VibeCodingPage />} />
        <Route path="/services/ai-ml-generative" element={<AIMLPage />} />
        <Route path="/services/digital-transformation" element={<DigitalTransformationPage />} />
        <Route path="/services/consulting" element={<ConsultingPage />} />
        <Route path="/services/business-intelligence" element={<BusinessIntelligencePage />} />
        <Route path="/services/cloud-development" element={<CloudDevelopmentPage />} />
        <Route path="/services/web-development" element={<WebDevelopmentPage />} />
        <Route path="/services/mobile-development" element={<MobileDevelopmentPage />} />
        <Route path="/portfolio" element={<PortfolioIndexPage />} />
        <Route path="/portfolio/onscript-ai" element={<OnScriptProjectPage />} />
        
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/survey" element={<ProjectSurveyPage />} />
        <Route path="/thanks" element={<ProjectThanksPage />} />
        
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </AIPromptProvider>
    </ProjectFormProvider>
  )
}

export default App
